import { Routes } from '@angular/router';
import { authGuard } from './shared/auth.guard';
import { adminGuard } from './shared/admin.guard';
import { DebugComponent } from './debug/debug.component';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },

  // Debug / safe mode: not displaying a lot of data like the dashboard
  { path: 'debug', component: DebugComponent },

  // Feature routes with modern lazy loading
  {
    path: 'harvest',
    loadChildren: () => import('./honey-house/honey-house.routes').then(r => r.routes),
  },
  {
    path: 'admin',
    canActivate: [authGuard, adminGuard],
    loadChildren: () => import('./admin/admin.routes').then(r => r.routes),
  },

  // Misc pages
  {
    path: 'home',
    loadComponent: () => import('./misc/dashboard/dashboard.component').then(c => c.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./misc/dashboard/dashboard.component').then(c => c.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'stats',
    loadComponent: () => import('./stats/stats-view/stats-view.component').then(c => c.StatsViewComponent),
    canActivate: [authGuard],
    title: 'Statistics'
  },
  {
    path: 'styleguide',
    loadComponent: () => import('./misc/styleguide/styleguide.component').then(c => c.StyleguideComponent)
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.routes').then(r => r.routes),
  },

  // Core feature routes
  {
    path: 'logs',
    loadChildren: () => import('./logs/logs.routes').then(r => r.routes),
  },
  {
    path: 'apiary',
    loadChildren: () => import('./apiary/apiary.routes').then(r => r.routes),
  },
  {
    path: 'hive',
    loadChildren: () => import('./hive/hive.routes').then(r => r.routes),
  },
  // Documents routes
  {
    path: 'documents',
    loadComponent: () => import('./inventory/document-view/document-view.component').then(c => c.DocumentViewComponent),
    canActivate: [authGuard]
  },
  {
    path: 'documents/add',
    loadComponent: () => import('./inventory/document-detail-view/document-detail-view.component').then(c => c.DocumentDetailViewComponent),
    canActivate: [authGuard]
  },
  {
    path: 'documents/:id',
    loadComponent: () => import('./inventory/document-detail-view/document-detail-view.component').then(c => c.DocumentDetailViewComponent),
    canActivate: [authGuard]
  },
  {
    path: 'inventory',
    loadChildren: () => import('./inventory/inventory.routes').then(r => r.routes),
  },
  // Notes routes
  {
    path: 'notes',
    loadChildren: () => import('./notes/notes.routes').then(r => r.routes),
  },

  // Auth routes
  {
    path: 'upgrade',
    loadComponent: () => import('./upgrade/upgrade.component').then(c => c.UpgradeComponent),
    data: { showSidebar: false }
  },
  {
    path: 'login',
    loadComponent: () => import('./user/login/login.component').then(c => c.LoginComponent)
  },
  {
    path: 'signup',
    loadComponent: () => import('./user/signup/signup.component').then(c => c.SignupComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./user/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent)
  },
  {
    path: 'reset-password/:token',
    loadComponent: () => import('./user/reset-password/reset-password.component').then(c => c.ResetPasswordComponent)
  },
  {
    path: 'account',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'account',
        pathMatch: 'full'
      },
      {
        path: 'account',
        loadComponent: () => import('./user/account/account.component').then(c => c.AccountComponent),
      },
      {
        path: 'settings',
        loadComponent: () => import('./settings/settings-view/settings-view.component').then(c => c.SettingsViewComponent),
      },
      {
        path: 'business',
        loadComponent: () => import('./settings/business-view/business-view.component').then(c => c.BusinessViewComponent),
      },
      {
        path: 'settings-options',
        loadComponent: () => import('./settings-options/settings-options-view/settings-options-view.component').then(c => c.SettingsOptionsViewComponent),
      },
    ]
  },
];
